import React from 'react'
import {BsClipboardData} from "react-icons/bs";
import {DiCodeigniter} from "react-icons/di";
import {GiCommercialAirplane} from "react-icons/gi";
import {FaMobileAlt} from "react-icons/fa";
import { BiRocket } from "react-icons/bi";
import { FaMapMarkedAlt } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";
import { FaRobot } from "react-icons/fa";
import { FaChartBar } from "react-icons/fa";

const homeConfig = {

    greeting:
        <h1 className="heading">
            Hi! I'm <strong className="main-name"> Jiangqin Ma</strong>
        </h1>,
titles: [
    "A Financial Data Analyst",
    "A Strategic Finance Lead",
    "A Quantitative Analyst",
    "An Accounting & Data Specialist",
],
   about: {
    start: "A Georgia Tech Analytics M.S. graduate and Financial Analyst with a strong foundation in accounting principles and ERP management. ",
    exit: "I specialize in automating AR/AP cycles, ensuring GAAP compliance, and leveraging SQL and Python to drive revenue recognition and cash flow optimization."
},
    workTimeline: [
    {
        id: "work-opc",
        title: "Accounting Assistant",
        company: "Oregon Potato Company",
        position: "left", 
        description: "Manage full-cycle Accounts Receivable (AR) and revenue recognition for high-volume customer contracts. " +
                     "Perform financial health assessments to mitigate credit risk, manage multi-jurisdictional tax compliance, " +
                     "and optimize the cash conversion cycle through cross-departmental collaboration.",
        date: "Sep 2025 – Present",
        icon: <FaChartLine />, // Keeping this as it matches your current screenshot
        tags: ["Accounts Receivable", "Revenue Recognition", "Credit Risk", "Tax Compliance", "ERP", "GAAP"]
    },
    {
        id: "work-phraseiq",
        title: "Strategic Finance Lead",
        company: "PhraseIQ",
        position: "right",
        description: "Architected InSightOS, an LLM-driven platform for automated financial analysis and capital planning. " +
                     "Developed real-time pipelines for GL, AP, and cash flow datasets to enable anomaly detection and " +
                     "predictive variance analysis while maintaining SOX-compliant documentation.",
        date: "May 2025 – Dec 2025",
       icon: <DiCodeigniter />,
        tags: ["Financial Modeling", "InSightOS", "Capital Planning", "Python", "SQL", "SOX Compliance"]
    },
    {
        id: "work-7",
        title: "Lead Data Scientist",
        company: "Connected to Culture",
        position: "left",
        description: "Implemented Machine Learning models for user engagement and content recommendation. \n" +
                 "Enhanced features using MongoDB. Expertise in GCP, full-stack development. " ,
        date: "Dec 2023 – Apr 2025",
        icon: <FaMobileAlt />,
        tags: ["ml", "SQL", "python", "GCP", "llm", "chatbot"]
    },
    {
        id: "work-6",
        title: "AI Data Analyst",
        company: "Labelbox",
        position: "right",
        description: "Conducted research per project guidelines to ensure data accuracy across maps, news, and audio tasks. Transformed raw data into actionable insights, enhancing content quality and user experience. Verified and categorized data to support reliable, data-driven decisions." ,
        date: "Apr 2024 – Apr 2026",
        icon: <FaChartBar />,
        tags: ["ml", "llm", "excel"]
    },
    {
        id: "work-5",
        title: "Researcher",
        company: "Georgia Tech",
        position: "left",
        description: "Mastered technologies including 3D laser scanning, LiDAR, and GPS. Employed machine learning and computer vision to innovate spatial-temporal GIS analyses and dynamic data analytics for mapping and forecasting.",
        date: "Jul 2024 – Jan 2025",
        icon: <BiRocket />,
        tags: ["ml", "deeplearning", "python", "gis", "lidar", "gps"]
    },
    {
        id: "work-4",
        title: "AI Researcher",
        company: "Blockonomics",
        position: "right",
        description: "Built advanced machine learning models to predict Bitcoin mempool behavior, improving transaction fee estimation. Developed a real-time trend forecasting system to help users reduce transaction costs.",
        date: "Aug 2024 – Dec 2024",
        icon: <DiCodeigniter />,
        tags: ["ml", "deeplearning", "python", "blockchain", "bitcoin"]
    },
    {
        id: "work-3",
        title: "Data Science Practicum",
        company: "The Home Depot",
        position: "left",
        description: "Engineered robust data pipelines to process diverse datasets for scalability. Implemented and fine-tuned Generative AI models for automated icon generation, achieving production-quality results.",
        date: "Apr 2024 – Aug 2024",
        icon: <FaRobot />,
        tags: ["ml", "deeplearning", "python", "generative ai", "hugging face"]
    },
]
}


export default homeConfig